import { getFileUrl } from "../../api/api";

export const THREE_D_EXTENSIONS = new Set([
  "glb",
  "gltf",
  "obj",
  "stl",
  "fbx",
  "ply",
  "3ds",
  "ifc",
  "rvt",
  "dwg",
  "bim",
]);

export const KML_EXTENSIONS = new Set(["kml", "kmz"]);
export const AUDIO_EXTENSIONS = new Set(["mp3", "wav", "ogg", "m4a", "aac", "flac"]);
export const BIM_EXTENSIONS = new Set(["ifc", "rvt", "dwg", "bim"]);
export const XER_EXTENSIONS = new Set(["xer"]);

export const DOCUMENT_EXTENSIONS = new Set([
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "csv",
  "ppt",
  "pptx",
  "txt",
  "rtf",
  "jpg",
  "jpeg",
  "png",
  "gif",
  "bmp",
  "webp",
  "svg",
]);

export const getFileName = (file) => {
  if (!file) return "";
  return file.orignalFileName || file.fileName || file.name || "";
};

const appendTokenToServeFileUrl = (url) => {
  if (!url || typeof url !== "string") return url;
  if (!url.includes("/filesysytem/serveFile")) return url;

  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const token = user?.auth_token || localStorage.getItem("access_token");
    if (!token) return url;

    const parsed = new URL(url, window.location.origin);
    if (!parsed.searchParams.get("token")) {
      parsed.searchParams.set("token", token);
    }
    return parsed.toString();
  } catch (e) {
    return url;
  }
};

export const getFileExtension = (file) => {
  if (!file) return "";
  const fromField = (file.extension || "").toString().replace(/^\./, "").toLowerCase();
  if (fromField) return fromField;

  const fileName = getFileName(file);
  const lastDot = fileName.lastIndexOf(".");
  if (lastDot === -1) return "";
  return fileName.slice(lastDot + 1).toLowerCase();
};

export const resolveFileUrl = (file, projectId) => {
  if (!file) return "";
  if (typeof file === "string") return file;

  // Prefer API-generated authenticated URLs for all internal project files.
  if (file._id || file.projectId || projectId) {
    return getFileUrl({
      projectId: file.projectId || projectId,
      folderPath: file.folderPath || file.path || "",
      fileName: file.orignalFileName || file.fileName || file.name,
      fileId: file._id,
    });
  }

  if (file.url) return appendTokenToServeFileUrl(file.url);
  if (file.fileUrl) return appendTokenToServeFileUrl(file.fileUrl);

  return "";
};
